import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BackNavigationService {
  private history: string[] = ['/'];
  private skipNextPush = false;

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.skipNextPush) {
          this.skipNextPush = false;
          return;
        }
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  public goBack() {
    if (this.history.length <= 1) {
      this.router.navigate(['/']);
    } else {
      this.skipNextPush = true;
      this.history.pop();
      const target = this.history[this.history.length - 1];
      this.router.navigateByUrl(target);
    }
  }

  public navigateAndSetBackUrl(
    url: string,
    backPath: string,
    savePreviousUrl: boolean = true
  ): any {
    //this.history.push(backPath);
    if (savePreviousUrl) {
      const currentUrl = this.location.path();
      const newUrl = `${currentUrl}/${url}`;
      this.router.navigateByUrl(newUrl);
      return;
    }
    this.router.navigateByUrl(url);
  }
}
